module.exports = __webpack_public_path__ + "img/08.fa874ef6.png";